/** Tiny event bus so the "Fråga AI" field on the start page can open the chat. */
type Listener = (question: string) => void;

const listeners = new Set<Listener>();
/** Fråga som ställdes innan chattwidgeten hunnit laddas (den laddas sent). */
let pending: string | null = null;
const requestListeners = new Set<() => void>();

export const openAiChat = (question = "") => {
  if (listeners.size === 0) {
    pending = question;
    requestListeners.forEach((listener) => listener());
    return;
  }
  listeners.forEach((listener) => listener(question));
};

export const subscribeAiChat = (listener: Listener) => {
  listeners.add(listener);
  if (pending !== null) {
    const question = pending;
    pending = null;
    listener(question);
  }
  return () => {
    listeners.delete(listener);
  };
};

/** Anropas när någon vill öppna chatten innan widgeten är laddad. */
export const onAiChatRequested = (listener: () => void) => {
  requestListeners.add(listener);
  return () => {
    requestListeners.delete(listener);
  };
};

const ANON_KEY = "elmarknad_ai_chat_id";

export const getAnonId = () => {
  if (typeof window === "undefined") return "";
  let id = window.localStorage.getItem(ANON_KEY);
  if (!id) {
    id = crypto.randomUUID();
    window.localStorage.setItem(ANON_KEY, id);
  }
  return id;
};

/** Delad kvotstatus så alla AI-fält visar samma antal kvarvarande frågor. */
export type AiChatQuotaSnapshot = {
  remaining: number;
  limit: number;
  period: string;
  signedIn: boolean;
  isAdmin: boolean;
};

type QuotaListener = (quota: AiChatQuotaSnapshot) => void;

const quotaListeners = new Set<QuotaListener>();
let lastQuota: AiChatQuotaSnapshot | null = null;

export const publishAiChatQuota = (quota: AiChatQuotaSnapshot) => {
  lastQuota = quota;
  quotaListeners.forEach((listener) => listener(quota));
};

export const getLastAiChatQuota = () => lastQuota;

export const subscribeAiChatQuota = (listener: QuotaListener) => {
  quotaListeners.add(listener);
  return () => {
    quotaListeners.delete(listener);
  };
};
